if (!customElements.get('product-card')) {
    class ProductCard extends HTMLElement {

      constructor() {
        super()
        this.handleProductCardSwatchClick();
        this.handleProductCardVariantClick();
      }

      handleInsideLinkClick = (event) => {
        event.preventDefault();
      }

      fetchProduct(event) {

        event.preventDefault();


        fetch(event.target.dataset.productUrl + '?view=card-product--swatches')
        .then(response => response.text())
        .then(text => {

          const newHtml = new DOMParser().parseFromString(text, 'text/html').querySelector('product-card').innerHTML;

          if (newHtml !== null) {
            this.innerHTML = newHtml;
            this.handleProductCardSwatchClick();
          }

        })
        .catch(e => {
          console.error(e);
        });

      }

      handleProductCardSwatchClick() {
        const swatches = this.querySelectorAll('product-group product-group-swatch');
        swatches.forEach((swatch) => {
          swatch.addEventListener('click', this.fetchProduct.bind(this));
          swatch.querySelector('a.product-group--item')?.classList.add('js-load');
          swatch.querySelector('a.product-group--item')?.addEventListener('click', this.handleInsideLinkClick);
        });
      }

      handleProductCardVariantClick() {
        let variants = this.querySelectorAll('.card-variant-selector button');
        let colourVariants = this.querySelectorAll('.shop-the-look__colour-variant .product-group--item');
        variants.forEach(variant => {
          variant.addEventListener('click', this.updateShopTheLookForm.bind(this));
        })
        colourVariants.forEach(variant => {
          variant.addEventListener('click', this.updateShopTheLookForm.bind(this));
        })
      }

      updateShopTheLookForm(e) {
        // colour variant clicked
        if (e.target.classList.contains('product-group--item')) {
          let colourVariants = this.querySelectorAll('.shop-the-look__colour-variant .product-group--item');
          colourVariants.forEach(variant => {
            variant.classList.remove('current');
          })
          e.target.classList.add('current');

          // update image
          if (document.body.classList.contains('gender-preference-male')) {
            this.querySelector('.card__media img.image-male-1').srcset = e.target.dataset.variantMaleSrcset;
            this.querySelector('.card__media img.image-male-1').src = e.target.dataset.variantImage;
          } else {
            this.querySelector('.card__media img.image-female-1').srcset = e.target.dataset.variantFemaleSrcset;
            this.querySelector('.card__media img.image-female-1').src = e.target.dataset.variantImage;
          }

          // get size variants
          const sizeVariantOptions = [
            {size: 'S', variantId: e.target.dataset.variantS},
            {size: 'M', variantId: e.target.dataset.variantM},
            {size: 'L', variantId: e.target.dataset.variantL},
            {size: 'XL', variantId: e.target.dataset.variantXl},
            {size: 'XXL', variantId: e.target.dataset.variantXxl}
          ];

          // update size selectors
          sizeVariantOptions.forEach(variant => {
            // get size variant button
            const el = this.querySelector(`.card-variant-selector button[data-option-title="${variant.size}"]`);
            // remove unavailable class
            el.closest('li').classList.remove('unavailable');

            // update data-id and add unavailable class if variant is sold out
            if (variant.variantId === '') {
              el.closest('li').classList.add('unavailable');
              el.dataset.id = variant.variantId;
            } else {
              el.dataset.id = variant.variantId;
            }

            // in case when on colour change the currently selected size is sold out, select first available size
            if(el.classList.contains('selected') && variant.variantId == '' ) {
              el.classList.remove('selected');
              let sizeVariants = this.querySelectorAll('.card-variant-selector button');
              for (let i = 0; i < sizeVariants.length; i++) {
                if (sizeVariants[i].dataset.id !== '') {
                  sizeVariants[i].click();
                  break;
                }
              }
            }
          });

        // size variant clicked
        } else {
          let sizeVariants = this.querySelectorAll('.card-variant-selector button');

          sizeVariants.forEach(variant => {
            variant.classList.remove('selected');
          });

          e.target.classList.add('selected');
          this.querySelector('variants-drawer-button span').dataset.currentSize =  e.target.innerHTML;
        }

        // if bundle pdp update form
        if (e.target.closest('.pdp-bundle-atc-form')) {
          let selectedProductCardIndex = [...document.querySelectorAll('.pdp-bundle-atc-form product-card')].indexOf(e.target.closest('product-card')) + 1;
          let shopTheLookForm = document.querySelector('.pdp-bundle-atc-form product-form')
          shopTheLookForm.querySelector(`input[name='items[${selectedProductCardIndex}][id]']`).value = this.querySelector('.card-variant-selector button.selected').dataset.id;
        // update shop the look form
        } else if (e.target.closest('shop-the-look-drawer')) {
          let selectedProductCardIndex = [...document.querySelectorAll('shop-the-look-drawer product-card')].indexOf(e.target.closest('product-card'))
          let shopTheLookForm = document.querySelector('shop-the-look-drawer product-form')
          shopTheLookForm.querySelector(`input[name='items[${selectedProductCardIndex}][id]']`).value = this.querySelector('.card-variant-selector button.selected').dataset.id;
        // update quick add form
        } else {
          const closestDrawer = e.target.closest('quick-add-drawer');
          closestDrawer.querySelector('.quick-add-drawer-input').value = this.querySelector('.card-variant-selector button.selected').dataset.id;
        }
      }
    }

    customElements.define('product-card', ProductCard)
  }
